<nz-select
  [ngModel]="selectedLang"
  (ngModelChange)="change($event)"
  style="min-width: 125px;"
  [nzCustomTemplate]="selectedTpl"
>
  <nz-option nzValue="vi" nzLabel="{{ 'language.vi' | transloco }}" [nzCustomContent]="true">
    <div class="d-flex align-items-center">
      <img src="assets/icons/vi.png" class="me-2" style="width: 16px; height: 16px;">
      <label>{{ 'language.vi' | transloco }}</label>
    </div>
  </nz-option>
  <nz-option nzValue="en" nzLabel="{{ 'language.en' | transloco }}" [nzCustomContent]="true">
    <div class="d-flex align-items-center me-2">
      <img src="assets/icons/en.png" class="me-2" style="width: 16px; height: 16px;">
      <label>{{ 'language.en' | transloco }}</label>
    </div>
  </nz-option>
</nz-select>

<ng-template #selectedTpl>
  <div class="d-flex align-items-center">
    <img [src]="'assets/icons/' + selectedLang + '.png'" class="me-2" style="width: 16px; height: 16px;">
    <label>{{ 'language.' + selectedLang | transloco }}</label>
  </div>
</ng-template>
